/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DisplayTypeEnum = {
    Toaster: 1
} as const;
export type DisplayTypeEnum = typeof DisplayTypeEnum[keyof typeof DisplayTypeEnum];


export function instanceOfDisplayTypeEnum(value: any): boolean {
    for (const key in DisplayTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DisplayTypeEnum, key)) {
            if (DisplayTypeEnum[key as keyof typeof DisplayTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DisplayTypeEnumFromJSON(json: any): DisplayTypeEnum {
    return DisplayTypeEnumFromJSONTyped(json, false);
}

export function DisplayTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayTypeEnum {
    return json as DisplayTypeEnum;
}

export function DisplayTypeEnumToJSON(value?: DisplayTypeEnum | null): any {
    return value as any;
}

export function DisplayTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DisplayTypeEnum {
    return value as DisplayTypeEnum;
}

